
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.22 14.715a1.302 1.302 0 01-.355-.455 1.34 1.34 0 01-.127-.563V8.24c0-1.16-.949-2.105-2.115-2.105H9.254a.435.435 0 01-.437-.464l.251-3.797A1.403 1.403 0 007.666.381a1.404 1.404 0 00-1.403 1.493l.25 3.797a.435.435 0 01-.437.464H4.709A2.113 2.113 0 002.593 8.24v6.042c0 .737.603 1.337 1.344 1.337h8.957c.22 0 .41-.133.483-.34a.505.505 0 00-.157-.564zM3.202 8.24c0-.824.676-1.495 1.506-1.495h1.369A1.046 1.046 0 007.122 5.63L6.87 1.833c-.002-.018-.001-.034-.001-.052 0-.436.357-.79.796-.79.223 0 .43.089.582.252a.782.782 0 01.212.59l-.251 3.798a1.047 1.047 0 001.045 1.114h1.369c.83 0 1.505.67 1.505 1.495v.443H3.202V8.24zm.734 6.77a.732.732 0 01-.734-.727v-4.99h8.927v4.404a1.916 1.916 0 00.517 1.313h-8.71z","fill":"currentColor"}})])
          )
        }
      }
    